import http from './http'
// import axios from 'axios'

// sysuser/mobile/register
export const register = ({ username, password, nickName, email, mobile, realName }) => {
  return http.post('apply/sysuser/mobile/register', {
    username, password, nickName, email, mobile, realName
  })
}

// sysuser/mobile/validate
export const validate = ({ username, mobile }) => {
  return http.get('apply/sysuser/mobile/validate', null, {
    params: {
      username,
      mobile
    }
  })
}
// /oauth/token?client_id=train_inline_tzsb&client_secret=Useihlle973_fj3fjx8_yy&grant_type=client_credentials&scope=read
export const oauthToken = () => {
  return http.post2('oauth/token?client_id=train_inline_tzsb&client_secret=Useihlle973_fj3fjx8_yy&grant_type=client_credentials&scope=read')
}

export const updateOpenId = (personCode) => {
  return http.post('apply/trainee/mobile/updateOpenId', null, {
    params: {
      personCode
    },
    noLoading: true
  })
}
// wechat/mobile/jsapi/{unitId}?url=
export const jsapiConfig = ({ unitId, url }) => {
  return http.get('wechat/mobile/jsapi/{unitId}', null, {
    params: {
      url, unitId
    },
    noLoading: true
  })
}

export const checkUser = ({ userName, passWord }) => {
  return http.post('loginuser/mobile/check', null, {
    params: {
      userName,
      passWord
    }
  })
}
